<template>
    <transition name="consent-slide">
        <div v-if="visible" class="cookie-banner" role="dialog" aria-label="Cookie consent" aria-live="polite">
            <div class="cookie-inner">
                <div class="cookie-text">
                    <i class="fas fa-cookie-bite cookie-icon"></i>
                    <span>
                        We use cookies to understand how visitors use our site and to improve your experience.
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Learn more</a>
                    </span>
                </div>
                <div class="cookie-actions">
                    <button class="btn-decline" @click="decline">Decline</button>
                    <button class="btn-accept" @click="accept">Accept All</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
const STORAGE_KEY = 'mp_cookie_consent';

export default {
    name: 'CookieConsent',
    data() {
        return {
            visible: false,
        };
    },
    mounted() {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'granted') {
            this.applyConsent(true, false);
        } else if (stored === 'declined') {
            // Already declined — stay denied, no banner needed
        } else {
            // No decision yet — show the banner
            this.visible = true;
        }
    },
    methods: {
        accept() {
            localStorage.setItem(STORAGE_KEY, 'granted');
            this.applyConsent(true, true);
            this.visible = false;
        },
        decline() {
            localStorage.setItem(STORAGE_KEY, 'declined');
            this.visible = false;
        },
        applyConsent(granted, isNewDecision) {
            if (!granted) return;

            // Update GA4 Consent Mode v2
            if (typeof gtag !== 'undefined') {
                gtag('consent', 'update', {
                    analytics_storage: 'granted',
                    ad_storage: 'denied',
                });
                // Fire the initial page view now that consent is granted
                if (isNewDecision) {
                    gtag('event', 'page_view', {
                        page_path: window.location.pathname,
                        page_title: document.title,
                    });
                }
            }

            // Inject Microsoft Clarity script dynamically
            if (!document.getElementById('clarity-script') && window.CLARITY_PROJECT_ID && window.CLARITY_PROJECT_ID !== 'CLARITY-XXXXXXXX') {
                const script = document.createElement('script');
                script.id = 'clarity-script';
                script.type = 'text/javascript';
                script.innerHTML = `
                    (function(c,l,a,r,i,t,y){
                        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                    })(window, document, "clarity", "script", window.CLARITY_PROJECT_ID);
                `;
                document.head.appendChild(script);
            }
        },
    },
};
</script>

<style scoped>
.cookie-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background-color: #054d81;
    color: #fff;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
}

.cookie-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 90vw;
    max-width: 1600px;
    margin: 0 auto;
    padding: 14px 0;
    flex-wrap: wrap;
}

.cookie-text {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.875rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    flex: 1;
    min-width: 240px;
}

.cookie-icon {
    font-size: 1.1rem;
    color: #ff6404;
    flex-shrink: 0;
}

.cookie-text a {
    color: rgba(255, 255, 255, 0.75);
    text-underline-offset: 3px;
}

.cookie-text a:hover {
    color: #fff;
}

.cookie-actions {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
}

.btn-decline,
.btn-accept {
    padding: 8px 20px;
    border-radius: 3px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s, color 0.2s;
    font-family: inherit;
}

.btn-decline {
    background-color: transparent;
    color: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-decline:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
}

.btn-accept {
    background-color: #ff6404;
    color: #fff;
}

.btn-accept:hover {
    background-color: #e05800;
}

.consent-slide-enter-active,
.consent-slide-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.consent-slide-enter-from,
.consent-slide-leave-to {
    transform: translateY(100%);
    opacity: 0;
}

@media (max-width: 600px) {
    .cookie-inner {
        flex-direction: column;
        align-items: flex-start;
        padding: 14px 0 16px;
    }

    .cookie-actions {
        width: 100%;
        justify-content: flex-end;
    }
}
</style>
